var template = require("./../templates/job-item.handlebars");

function trackJobClick(jobId, url) {
  fetch("/api/analytics/track_event", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_type: "job_click",
      job_id: jobId,
      source_surface: "job_board",
      target_url: url,
    }),
    keepalive: true,
  }).catch(function () {});
}

$(function () {
  // Fire a job_click on every job listing link (paid + aggregator) so we can
  // measure clicks per job and, in particular, per featured/paid posting.
  $(document).on("click", ".job-link", function () {
    var jobId = $(this).data("job-id");
    if (jobId !== undefined && jobId !== null && jobId !== "") {
      trackJobClick(jobId, this.href);
    }
  });
});
